import React from "react";
import "./orderTrack.css";
import { useUpdateOrderMutation } from "../../services/orderApi";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useState } from "react";
import { LocalShipping, House, Cancel } from "@mui/icons-material";
import { FaBoxOpen } from 'react-icons/fa';
import { CgNotes } from 'react-icons/cg';
import { BsCheckCircle } from 'react-icons/bs';

function OrderTrack(props) {
  const [updateOrder] = useUpdateOrderMutation();
  
  const [data, setData] = useState({
    id: props.data.order_Id,
    order_Status: props.data.order_Status,
  });

  if(data.order_Status === "Canceled") {
    return (
      <div className="order-track-main">
        <h3 className="order-track-title">Order Status</h3>
        <ul className="order-track-steps">
          <li className="order-track-step canceled-step">
            <div className="step-content">
              <CgNotes className="order-track-step-icon" />
              <div className="order-track-canceled-first">
                <Cancel />
              </div>
              <p className="order-track-step-text">Order Placed</p>
            </div>
          </li>
          <li className="order-track-step canceled-step">
            <div className="step-content">
              <FaBoxOpen className="order-track-step-icon" />
              <div className="order-track-canceled">
                <Cancel />
              </div>
              <p className="order-track-step-text">Under Package</p>
            </div>
          </li>
          <li className="order-track-step canceled-step">
            <div className="step-content">
              <LocalShipping className="order-track-step-icon" />
              <div className="order-track-canceled">
                <Cancel />
              </div>
              <p className="order-track-step-text">On The way</p>
            </div>
          </li>
          <li className="order-track-step canceled-step">
            <div className="step-content">
              <House className="order-track-step-icon" />
              <div className="order-track-canceled">
                <Cancel />
              </div>
              <p className="order-track-step-text">Delivered</p>
            </div>
          </li>
          <li className="order-track-step canceled-step">
            <div className="step-content">
              <Cancel className="order-track-step-icon" />
              <div className="order-track-canceled">
                <BsCheckCircle />
              </div>
              <p className="order-track-step-text">Canceled</p>
            </div>
          </li>
        </ul>
      </div>
    );
  }

  let activeBar = 0;
  if (data.order_Status === "Order Placed") {
    activeBar = 1;
  } else if (data.order_Status === "Under Package") {
    activeBar = 2;
  } else if (data.order_Status === "On The way to deliver") {
    activeBar = 3;
  } else if (data.order_Status === "Delivered") {
    activeBar = 4;
  }

  const handleUpdate = (orderStatus) => {
    const actualData = {
      id: data.id,
      order_Status: orderStatus
    };
    
    confirmAlert({
      title: `Update Order Status to ${orderStatus}`,
      message: 'Are you sure to Update Order Status?',
      buttons: [
        {
          label: 'Yes',
          onClick: async () => {
            try {
              setData({
                id: data.id,
                order_Status: orderStatus
              });
              
              const res = await updateOrder(actualData);
              if(res.isError) {
                console.error("Update error:", res.error.error);
              }
              if(res.data) {
                console.log("Update status response:", res.data);
              }
            } catch (error) {
              console.error("Error updating order:", error);
            }
          }
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  };

  return (
    <div className="order-track-main">
      <h3 className="order-track-title">Order Status</h3>
      <ul className="order-track-steps">
        <li className={`order-track-step ${activeBar >= 1 ? 'active-step' : ''}`}>
          <div className="step-content">
            <CgNotes className="order-track-step-icon" />
            <div
              className={`order-track-progress order-track-progress-first ${activeBar >= 1 ? 'order-track-progress-active' : ''}`}
              onClick={() => handleUpdate("Order Placed")}
            >
              <BsCheckCircle className="order-track-progress-icon" />
            </div>
            <p className="order-track-step-text">Order Placed</p>
          </div>
        </li>
        <li className={`order-track-step ${activeBar >= 2 ? 'active-step' : ''}`}>
          <div className="step-content">
            <FaBoxOpen className="order-track-step-icon" />
            <div
              className={`order-track-progress ${activeBar >= 2 ? 'order-track-progress-active' : ''}`}
              onClick={() => handleUpdate("Under Package")}
            >
              <BsCheckCircle className="order-track-progress-icon" />
            </div>
            <p className="order-track-step-text">Under Package</p>
          </div>
        </li>
        <li className={`order-track-step ${activeBar >= 3 ? 'active-step' : ''}`}>
          <div className="step-content">
            <LocalShipping className="order-track-step-icon" />
            <div
              className={`order-track-progress ${activeBar >= 3 ? 'order-track-progress-active' : ''}`}
              onClick={() => handleUpdate("On The way to deliver")}
            >
              <BsCheckCircle className="order-track-progress-icon" />
            </div>
            <p className="order-track-step-text">On The way</p>
          </div>
        </li>
        <li className={`order-track-step ${activeBar >= 4 ? 'active-step' : ''}`}>
          <div className="step-content">
            <House className="order-track-step-icon" />
            <div
              className={`order-track-progress ${activeBar >= 4 ? 'order-track-progress-active' : ''}`}
              onClick={() => handleUpdate("Delivered")}
            >
              <BsCheckCircle className="order-track-progress-icon" />
            </div>
            <p className="order-track-step-text">Delivered</p>
          </div>
        </li>
      </ul>
    </div>
  );
}

export default OrderTrack;